(function() {
  const CHANNEL = 'RESELLER';

  function isQuestionnaireSubmitting() {
    return Boolean(document.querySelector('.partnership-form__submit [aria-busy="true"], .partnership-form__submit[aria-busy="true"]'));
  }

  function notifyQuestionnaireCategory(category) {
    document.dispatchEvent(new CustomEvent('partnerCategoryChange', {
      detail: { category: category }
    }));
  }

  function getActivePartnerCategory() {
    return document.querySelector('[data-partner-tab].partner-with-us__tab--active')?.dataset.partnerTab || CHANNEL;
  }

  function refreshPartnerCarousel() {
    if (!window.TakeDriveCarousel || typeof window.TakeDriveCarousel.refresh !== 'function') return;
    window.TakeDriveCarousel.refresh();
  }

  function initPartnerCarousel(scope) {
    if (!window.TakeDriveCarousel || typeof window.TakeDriveCarousel.init !== 'function') return;
    window.TakeDriveCarousel.init([
      {
        selector: '.partner-with-us__carousel',
        trackSelector: '.partner-with-us__track',
        slideSelector: '.partner-with-us__slide'
      }
    ], scope || document);
  }

  function setPartnerCategory(category, syncQuestionnaire) {
    if (syncQuestionnaire && isQuestionnaireSubmitting()) return;
    document.querySelectorAll('[data-partner-tab]').forEach(function(tab) {
      const isActive = tab.dataset.partnerTab === category;
      tab.classList.toggle('partner-with-us__tab--active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    document.querySelectorAll('[data-partner-panel]').forEach(function(panel) {
      const isActive = panel.dataset.partnerPanel === category;
      panel.hidden = !isActive;
      panel.classList.toggle('partner-with-us__option--active', isActive);
    });

    document.querySelectorAll('[data-partner-detail]').forEach(function(section) {
      const isActive = section.dataset.partnerDetail === category;
      section.hidden = !isActive;
      const gridRoot = section.closest('[id^="partner-with-us-"]');
      if (gridRoot) gridRoot.hidden = !isActive;
      if (isActive) {
        window.requestAnimationFrame(function() {
          section.dispatchEvent(new CustomEvent('partnerCarouselRefresh'));
          refreshPartnerCarousel();
        });
      }
    });

    if (syncQuestionnaire) {
      notifyQuestionnaireCategory(category);
    }
  }

  function initPartnerUi(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-partner-tab]').forEach(function(tab) {
      if (tab.dataset.partnerTabInitialized === 'true') return;
      tab.dataset.partnerTabInitialized = 'true';
      tab.addEventListener('click', function() {
        setPartnerCategory(tab.dataset.partnerTab, true);
      });
    });

    root.querySelectorAll('[data-partnership-category]').forEach(function(link) {
      if (link.dataset.partnerLinkInitialized === 'true') return;
      link.dataset.partnerLinkInitialized = 'true';
      link.addEventListener('click', function() {
        setPartnerCategory(link.dataset.partnershipCategory || CHANNEL, true);
      });
    });

    initPartnerCarousel(root);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initPartnerUi(document);
    const activeCategory = getActivePartnerCategory();
    setPartnerCategory(activeCategory, false);
    setTimeout(function() {
      const resolvedCategory = getActivePartnerCategory();
      setPartnerCategory(resolvedCategory, false);
    }, 400);
  });
  document.addEventListener('shopify:section:load', function(event) {
    initPartnerUi(event.target);
    setPartnerCategory(getActivePartnerCategory(), false);
  });
})();
